import { PHONE, locationSchema } from "../structured-data-core";

export function getNassauCountyStructuredData() {
  const url = "https://restorehair.com/locations/new-york/nassau-county/";
  const description =
    "Find out about your hair transplant options in Nassau County with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Nassau County", "1979 Marcus Ave, Suite 210", "Lake Success", "NY", PHONE, url, description),
  ];
}
